<template>
  <transition name='basic' v-if='kirby.site'>
    <div id='Subscribe-Popup' v-show='show && !closed && dismissed!="true"'>
      <svg class='close' viewBox='0 0 44 44' @click='dismiss()'>
        <path fill="#cce8ec" d="M21.97 43.93a22 22 0 1 0-22-22 22 22 0 0 0 22 22"/>
        <path fill="#33a3b1" d="m32.21 30.5-8.12-8.11 8.11-8.12-2.12-2.12-8.12 8.11-8.11-8.11-2.12 2.12 8.11 8.12-8.11 8.11 2.12 2.12 8.11-8.11 8.13 8.12 2.12-2.13z"/>
      </svg>
      <figure>
        <img v-if='kirby.site.content' :src='yaml(kirby.site.content.subscribeimage.value)[0]'/>
        <hr class='gray' />
        <hr class='green' />
        <hr class='blue' />
      </figure>
      <section v-if='kirby.site.content' id="mailchimp">
        <summary v-if='kirby.site.content.block_2' v-html='kirby.site.content.block_2.kirbytext' />
        <small v-if='kirby.site.content.block_2_small' v-html='kirby.site.content.block_2_small.kirbytext' />
        <br />
        <small v-if='kirby.site.content.block_2_questions' v-html='kirby.site.content.block_2_questions.kirbytext' />
      </section>
    </div>
  </transition>
</template>

<script>
import Vue from 'vue'
import mixins from '.././mixins.js';
import VueCookies from 'vue-cookies';
Vue.use(VueCookies);

export default {
mixins: [mixins], //kirby(), urltopath(), etc
data: function() {
  return {
    closed: false,
    show: false
  }
},
mounted() {
  var self = this;
  setTimeout(() => { self.show = true }, 5000);
},
computed: {
  dismissed: function() {
    return $cookies.get('dismissed');
  }
},
  methods: {
    dismiss: function() {
      console.log($cookies.get('dismissed'));
      this.closed=true;
      var dismissed = $cookies.set('dismissed', 'true');
      return dismissed
    }
  }
}
</script>

<style>
  #Subscribe-Popup {
    position: fixed;
    width: 18rem;
    bottom: 3rem;
    right: 2rem;
    background-color: var(--lightmint);
    max-width: var(--main-max-width);
    box-sizing: border-box;
    padding: 0;
    border-radius: 2rem;
    text-align: left;
    z-index: 999;
    box-shadow: 0rem 0.25rem 0.5rem var(--blueopacity);
    overflow: hidden;
  }

  #Subscribe-Popup section {
    padding: 1.85rem;
  }

  #Subscribe-Popup svg.close {
    position: absolute;
    top: 1rem;
    right: 1rem;
    width: 2rem;
    z-index: 2;
    cursor: pointer;
    transition: transform 0.3s ease-out;
  }

  #Subscribe-Popup svg.close:hover {
    transform: scale(1.05);
  }

  #Subscribe-Popup figure {
    padding: 0;
    margin: 0;
    width: 100%;
    height: 12rem;
    position: relative;
  }

  #Subscribe-Popup figure img {
    padding: 0;
    margin: 0;
    width: 100%;
    position: absolute;
    object-fit: cover;
  }

  #Subscribe-Popup figure hr {
    position: absolute;
    height: 100%;
    width: 100%;
    margin: 0;
    padding: 0;
    outline: none;
    border: none;
  }

  #Subscribe-Popup hr.green {
    background-color: var(--brightgreentint);
    mix-blend-mode: multiply;
  }

  #Subscribe-Popup hr.blue {
    background-color: var(--blue);
    mix-blend-mode: screen;
  }

  #Subscribe-Popup hr.gray {
    background-color: #aaa;
    mix-blend-mode: color;
  }
</style>
